import { DialogType } from '@tableau/widgets';
import * as React from 'react';
import { EditSiteMembershipDialog } from '../components/EditSiteMembershipDialog';
import { IServerUserInfo } from '../../ts/models/IServerUserInfo';
import { Set } from '../../ts/models/Set';
import { ModalInstance, ReactModalService } from '../../commonInfra/dialogs/ReactModalService';

const serverAndSiteUsersDialogStyle: React.CSSProperties = {
  width: 'auto',
  height: 'auto',
  paddingTop: '18px',
  paddingBottom: '12px',
  paddingLeft: '12px',
  paddingRight: '12px'
};

function showEditSiteMembershipDialog(
  users: Set<IServerUserInfo>): Promise<any> {

  let modalInstance: ModalInstance;

  const dialogProps = {
    dismiss: () => modalInstance && modalInstance.dismiss('cancel'),
    close: (result: any) => modalInstance && modalInstance.close(result),
    users: users
  };

  modalInstance = ReactModalService.open({
    type: DialogType.Uber,
    dialogContent: React.createElement(EditSiteMembershipDialog, dialogProps),
    testId: 'addEditSiteMembershipDialog',
    showCloseButton: true,
    dialogStyle: serverAndSiteUsersDialogStyle,
    shouldNotSetDefaultWidth: true
  });

  return Promise.resolve(modalInstance.result);
}

export const EditSiteMembershipAction = {
  showEditSiteMembershipDialog
};
